import { Injectable } from '@angular/core';
import { AuthError, AuthErrorsTypes } from '@services/auth-services/models';

const ProviderErrorsMap: any = {
  'auth/email-already-in-use': AuthErrorsTypes.EMAIL_EXISTS,
  'auth/invalid-credential': AuthErrorsTypes.INVALID_LOGIN_CREDENTIALS,
  'auth/user-not-found': AuthErrorsTypes.USER_NOT_FOUND,
  'auth/wrong-password': AuthErrorsTypes.INVALID_LOGIN_CREDENTIALS,
  'auth/invalid-tenant-id': AuthErrorsTypes.MISSING_ORGANIZATION,
  'auth/operation-not-allowed': AuthErrorsTypes.SIGN_IN_METHOD_FORBIDDEN,
  'auth/provider-already-linked': AuthErrorsTypes.PROVIDER_ALREADY_LINKED,
  'auth/too-many-requests': AuthErrorsTypes.TOO_MANY_REQUESTS,
  'auth/account-exists-with-different-credential':
    AuthErrorsTypes.ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS,
};

const ErrorsMap: AuthError[] = [
  { key: AuthErrorsTypes.EMAIL_EXISTS, message: 'This email is already taken' },
  { key: AuthErrorsTypes.EMAIL_NOT_FOUND, message: 'Email not found' },
  { key: AuthErrorsTypes.INVALID_LOGIN_CREDENTIALS, message: 'Invalid login credentials.' },
  { key: AuthErrorsTypes.EMAIL_NOT_VERIFIED, message: 'Email is not verified.' },
  { key: AuthErrorsTypes.MISSING_ROLES, message: 'Roles are not defined for the organization.' },
  { key: AuthErrorsTypes.MISSING_SUBDOMAIN, message: 'Missing organization subdomain' },
  { key: AuthErrorsTypes.MISSING_ORGANIZATION, message: "Organization doesn't exist." },
  {
    key: AuthErrorsTypes.USER_NOT_FOUND,
    message: "This email isn't registered for this organization.",
  },
  {
    key: AuthErrorsTypes.SIGN_IN_METHOD_FORBIDDEN,
    message: 'Sign-in method is disabled for organization.',
  },
  {
    key: AuthErrorsTypes.PROVIDER_ALREADY_LINKED,
    message: 'Password is already created for this account.',
  },
  {
    key: AuthErrorsTypes.ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS,
    message: 'There is already an account with same email and different credentials.',
  },
  {
    key: AuthErrorsTypes.TOO_MANY_REQUESTS,
    message:
      'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.',
  },
];

@Injectable({ providedIn: 'root' })
export class AuthErrorsService {
  getError(key: string): AuthError {
    // See if key exists in provider errors map, so we can re-map it to internal error codes.
    const internalKey = ProviderErrorsMap[key] || key;
    return (
      ErrorsMap.find(e => e.key === internalKey) || {
        key: AuthErrorsTypes.UNHANDLED_ERROR,
        message: `Key ${key} is not known error code`,
      }
    );
  }
}
